import { ensureTab, appendRow } from '../lib/googleSheets';

const TABLE_NAME = 'VideoLeads';
const HEADERS = ['id', 'name', 'whatsapp', 'business', 'goal', 'link', 'created_at'];

export const submitVideoLead = async (leadData) => {
  await ensureTab(TABLE_NAME, HEADERS);
  
  const row = [
    crypto.randomUUID(),
    leadData.name,
    leadData.whatsapp,
    leadData.business,
    leadData.goal,
    leadData.link || '',
    new Date().toISOString()
  ];

  return appendRow(`${TABLE_NAME}!A:Z`, row);
};
